module.exports = __webpack_public_path__ + "media/images/supporters_lp/fork21-49b5ca0f6765ee87c53aa1b87f4f6fa9.png";